export interface Attrs {
  version: string;
  batchNo: string;
  batchDateTime: Date;
  messageID: string;
  transmissionID: string;
}

export interface Attrs2 {
  code: string;
  name: string;
  abbreviatedName: string;
}

export interface Attrs3 {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface Address {
  $attrs: Attrs3;
}

export interface Attrs4 {
  language: string;
  default: string;
}

export interface Localization {
  $attrs: Attrs4;
  Text: string[];
}

export interface ReportHeader {
  Localization: Localization[];
}

export interface Sender {
  $attrs: Attrs2;
  Address: Address[];
  ReportHeader: ReportHeader[];
}

export interface Attrs5 {
  code: string;
  name: string;
  abbreviatedName: string;
  language: string;
  type: string;
  email: string;
  patientReference: string;
}

export interface Attrs6 {
  type: string;
  version: string;
  value: string;
}

export interface Code {
  $attrs: Attrs6;
}

export interface Attrs7 {
  type: string;
  number: string;
}

export interface Telephone {
  $attrs: Attrs7;
}

export interface Attrs8 {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface Address2 {
  $attrs: Attrs8;
}

export interface Recipient {
  $attrs: Attrs5;
  Code: Code[];
  Telephone: Telephone[];
  Address: Address2[];
}

export interface Attrs9 {
  database: string;
  urn: string;
  mri: string;
  surname: string;
  firstName: string;
  title: string;
  idNumber: string;
  age: string;
  sex: string;
  dateOfBirth: string;
  serviceDate: string;
}

export interface Attrs10 {
  type: string;
  number: string;
}

export interface Telephone2 {
  $attrs: Attrs10;
}

export interface Attrs11 {
  address: string;
}

export interface Email {
  $attrs: Attrs11;
}

export interface Attrs12 {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface Address3 {
  $attrs: Attrs12;
}

export interface Attrs13 {
  code: string;
  name: string;
  abbreviatedName: string;
  language: string;
  type: string;
  email: string;
}

export interface Attrs14 {
  type: string;
  number: string;
}

export interface Telephone3 {
  $attrs: Attrs14;
}

export interface Attrs15 {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface Address4 {
  $attrs: Attrs15;
}

export interface RegisteringDoctor {
  $attrs: Attrs13;
  Telephone: Telephone3[];
  Address: Address4[];
}

export interface Attrs16 {
  code: string;
  name: string;
  abbreviatedName: string;
}

export interface Location {
  $attrs: Attrs16;
}

export interface Attrs17 {
  urn: string;
  number: string;
}

export interface Attrs18 {
  gid: string;
  surname: string;
  firstName: string;
}

export interface Attrs19 {
  type: string;
  number: string;
}

export interface Telephone4 {
  $attrs: Attrs19;
}

export interface Attrs20 {
  address: string;
}

export interface Email2 {
  $attrs: Attrs20;
}

export interface Attrs21 {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface Address5 {
  $attrs: Attrs21;
}

export interface Attrs22 {
  code: string;
  name: string;
}

export interface Insurance {
  $attrs: Attrs22;
}

export interface Guarantor {
  $attrs: Attrs18;
  Telephone: Telephone4[];
  Email: Email2[];
  Address: Address5[];
  Insurance: Insurance[];
}

export interface Account {
  $attrs: Attrs17;
  Guarantor: Guarantor[];
}

export interface Attrs23 {
  database: string;
  urn: string;
  number: string;
  priority: string;
  orderNo: string;
}

export interface Attrs24 {
  code: string;
  name: string;
}

export interface Attrs25 {
  value: string;
}

export interface Answer {
  $attrs: Attrs25;
}

export interface Question {
  $attrs: Attrs24;
  Answer: Answer[];
}

export interface ClinicalInfo {
  Question: Question[];
}

export interface Attrs26 {
  code: string;
  name: string;
  abbreviatedName: string;
}

export interface Attrs27 {
  type: string;
  version: string;
  value: string;
}

export interface Code2 {
  $attrs: Attrs27;
}

export interface Item {
  $attrs: Attrs26;
  Code: Code2[];
}

export interface Order {
  Item: Item[];
}

export interface Attrs28 {
  code: string;
  name: string;
  abbreviatedName: string;
  language: string;
  type: string;
  email: string;
}

export interface Attrs29 {
  type: string;
  version: string;
  value: string;
}

export interface Code3 {
  $attrs: Attrs29;
}

export interface Attrs30 {
  type: string;
  number: string;
}

export interface Telephone5 {
  $attrs: Attrs30;
}

export interface Attrs31 {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface Address6 {
  $attrs: Attrs31;
}

export interface SubmittingDoctor {
  $attrs: Attrs28;
  Code: Code3[];
  Telephone: Telephone5[];
  Address: Address6[];
}

export interface Attrs32 {
  code: string;
  name: string;
  abbreviatedName: string;
  language: string;
  type: string;
  email: string;
  id: string;
}

export interface Attrs33 {
  type: string;
  version: string;
  value: string;
}

export interface Code4 {
  $attrs: Attrs33;
}

export interface Attrs34 {
  type: string;
  number: string;
}

export interface Telephone6 {
  $attrs: Attrs34;
}

export interface Attrs35 {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface Address7 {
  $attrs: Attrs35;
}

export interface OtherDoctor {
  $attrs: Attrs32;
  Code: Code4[];
  Telephone: Telephone6[];
  Address: Address7[];
}

export interface Attrs36 {
  urn: string;
  number: string;
  type: string;
  reportDate: string;
  reportTime: string;
  reportType: string;
  referenceAge: string;
  status: string;
}

export interface Attrs37 {
  code: string;
  name: string;
  collectionDate: string;
  collectionTime: string;
}

export interface CollectedBy {
  $attrs: Attrs37;
}

export interface Attrs38 {
  code: string;
  name: string;
  receivedDate: string;
  receivedTime: string;
}

export interface ReceivedBy {
  $attrs: Attrs38;
}

export interface Attrs39 {
  code: string;
  name: string;
  abbreviatedName: string;
}

export interface Attrs40 {
  type: string;
  version: string;
  value: string;
}

export interface Code5 {
  $attrs: Attrs40;
}

export interface Item2 {
  $attrs: Attrs39;
  Code: Code5[];
}

export interface Order2 {
  Item: Item2[];
}

export interface Attrs41 {
  language: string;
  default: string;
}

export interface Localization2 {
  $attrs: Attrs41;
  Text: string[];
}

export interface Comment {
  Localization: Localization2[];
}

export interface Attrs42 {
  code: string;
  name: string;
  abbreviatedName: string;
}

export interface Department {
  $attrs: Attrs42;
}

export interface Attrs43 {
  code: string;
  name: string;
}

export interface OrderSite {
  $attrs: Attrs43;
}

export interface Attrs44 {
  code: string;
  name: string;
  abbreviatedName: string;
  status: string;
}

export interface Attrs45 {
  code: string;
  name: string;
  abbreviatedName: string;
  confidential: string;
  reportable: string;
  status: string;
}

export interface Attrs46 {
  type: string;
  version: string;
  value: string;
}

export interface Code6 {
  $attrs: Attrs46;
}

export interface Attrs47 {
  language: string;
  name: string;
  abbreviatedName: string;
}

export interface Localization3 {
  $attrs: Attrs47;
}

export interface Attrs48 {
  code: string;
  name: string;
  abbreviatedName: string;
  value: string;
  type: string;
  units: string;
  range: string;
  flag: string;
  revisionNo: string;
}

export interface Attrs49 {
  language: string;
  default: string;
}

export interface Localization4 {
  $attrs: Attrs49;
  Text: string[];
}

export interface Comment2 {
  Localization: Localization4[];
}

export interface Attrs50 {
  sequence: string;
  type: string;
  code: string;
  name: string;
}

export interface Diagnosis {
  $attrs: Attrs50;
}

export interface Result {
  $attrs: Attrs48;
  Comment: Comment2[];
  Diagnosis: Diagnosis[];
}

export interface Test {
  $attrs: Attrs45;
  Code: Code6[];
  Localization: Localization3[];
  Result: Result[];
}

export interface Procedure {
  $attrs: Attrs44;
  Test: Test[];
}

export interface Specimen {
  $attrs: Attrs36;
  CollectedBy: CollectedBy[];
  ReceivedBy: ReceivedBy[];
  Orders: Order2[];
  Comment: Comment[];
  Department: Department[];
  OrderSite: OrderSite[];
  Procedure: Procedure[];
}

export interface Requisition {
  $attrs: Attrs23;
  ClinicalInfo: ClinicalInfo[];
  Orders: Order[];
  SubmittingDoctor: SubmittingDoctor[];
  OtherDoctor: OtherDoctor[];
  Specimen: Specimen[];
}

export interface Patient {
  $attrs: Attrs9;
  Telephone: Telephone2[];
  Email: Email[];
  Address: Address3[];
  RegisteringDoctor: RegisteringDoctor[];
  Location: Location[];
  Account: Account[];
  Requisition: Requisition[];
}

export interface PathologyReport {
  $attrs: Attrs;
  Sender: Sender[];
  Recipient: Recipient[];
  Patient: Patient[];
}

export interface Root {
  PathologyReports: {
    PathologyReport: PathologyReport[];
  };
}
